import { useTranslation } from 'react-i18next';

import { Icon, Tooltip } from '~/components';
import { DISTRIBUTION_TERRITORIES } from '~settings/api/lib/types';

export function DistributionRegions({
  countries,
  region,
}: {
  countries: { value: string; label: string }[];
  region: DISTRIBUTION_TERRITORIES;
}) {
  const { t } = useTranslation('settings', { keyPrefix: 'label' });

  const messageKey =
    region === DISTRIBUTION_TERRITORIES.OnlyIn
      ? 'selectedTerritories'
      : 'excludedTerritories';

  return (
    <span>
      {region !== DISTRIBUTION_TERRITORIES.Worldwide ? (
        <>
          {t(messageKey, { numCountries: countries.length })}
          <Tooltip
            content={countries.map((country) => country.label).join(', ')}
            side="top"
            delayDuration={0}
          >
            <Icon
              type="circle-info"
              variant="light"
              className="ml-sm text-subtlest"
              size="sm"
            />
          </Tooltip>
        </>
      ) : (
        t('worldwide')
      )}
    </span>
  );
}

DistributionRegions.displayName = 'DistributionRegions';
